/**
 * Keeps every savings percentage on the storefront rounded DOWN to a
 * multiple of five. Liquid already renders it that way server-side, but
 * theme.js rewrites the product-page badge on every variant change — this
 * re-applies the rule to whatever it wrote, instead of patching the 230 KB
 * vendor bundle. Rounding down never overstates the real reduction, which
 * EU/DK price-marketing rules require.
 */
(function () {
  'use strict';

  var SELECTOR = '.product__price-savings, .grid-product__price--savings';
  var PERCENT = /(\d+)\s*%/;
  var queued = false;

  function apply(el) {
    var text = el.textContent;
    var match = text.match(PERCENT);
    if (!match) return;

    var raw = parseInt(match[1], 10);
    var rounded = Math.floor(raw / 5) * 5;

    // Nothing sensible to advertise below 5% — "Spar 0%" reads as a bug.
    if (rounded < 5) {
      el.style.display = 'none';
      return;
    }

    el.style.display = '';
    if (rounded === raw) return;
    el.textContent = text.replace(PERCENT, rounded + '%');
  }

  function sweep() {
    queued = false;
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), apply);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sweep);
  }

  sweep();

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();